import { apiClient } from '@/core/infra_api_client'

// ============= Types =============

export type ComplianceStatus = 'passing' | 'failing' | 'warning' | 'not_applicable'
export type ComplianceSeverity = 'critical' | 'high' | 'medium' | 'low'

export interface ComplianceCheck {
  id: string
  environmentId: string
  name: string
  description: string
  framework: string
  controlId: string
  status: ComplianceStatus
  severity: ComplianceSeverity
  lastCheckedAt: string
  details?: Record<string, unknown>
}

export interface ComplianceReport {
  id: string
  environmentId: string
  framework: string
  generatedAt: string
  summary: {
    total: number
    passing: number
    failing: number
    warning: number
  }
  checks: ComplianceCheck[]
}

export interface RunScanRequest {
  environmentId: string
  framework?: string
}

export interface PaginatedResponse<T> {
  data: T[]
  total: number
  page: number
  perPage: number
  totalPages: number
}

// ============= API =============

const BASE_PATH = 'compliance'

export async function listChecks(params?: {
  page?: number
  perPage?: number
  environmentId?: string
  status?: string
  framework?: string
}): Promise<PaginatedResponse<ComplianceCheck>> {
  const searchParams: Record<string, string | number | boolean> = {}
  if (params?.page) searchParams['page'] = params.page
  if (params?.perPage) searchParams['per_page'] = params.perPage
  if (params?.environmentId) searchParams['environment_id'] = params.environmentId
  if (params?.status) searchParams['status'] = params.status
  if (params?.framework) searchParams['framework'] = params.framework

  return apiClient.get<PaginatedResponse<ComplianceCheck>>(`${BASE_PATH}/checks`, searchParams)
}

export async function getReport(params?: {
  environmentId?: string
  framework?: string
}): Promise<ComplianceReport> {
  const searchParams: Record<string, string | number | boolean> = {}
  if (params?.environmentId) searchParams['environment_id'] = params.environmentId
  if (params?.framework) searchParams['framework'] = params.framework

  return apiClient.get<ComplianceReport>(`${BASE_PATH}/report`, searchParams)
}

export async function runScan(data: RunScanRequest): Promise<ComplianceReport> {
  return apiClient.post<ComplianceReport, RunScanRequest>(`${BASE_PATH}/scan`, data)
}
